import { jsx as _jsx } from "react/jsx-runtime";
import { colors, typography } from '@mehilainen/design-system-tokens';
// NOTE: Do not import these from lib root! Will cause circular deps
import { RadioOnAlt, RadioOff, CheckboxOn, CheckboxOff } from '../../icons';
import { focusVisible } from './shared';
export const getThemeSelections = (tokens) => ({
    MuiRadio: {
        defaultProps: {
            checkedIcon: (_jsx(RadioOnAlt, { sx: {
                    width: tokens.uiElementSelections.iconSize,
                    height: tokens.uiElementSelections.iconSize,
                } })),
            icon: (_jsx(RadioOff, { sx: {
                    width: tokens.uiElementSelections.iconSize,
                    height: tokens.uiElementSelections.iconSize,
                } })),
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                padding: 0,
                color: colors.Primary500,
                '&[class*="Mui-disabled"]': {
                    color: colors.Gray500, // Icon color
                },
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                '&[class*="Mui-focusVisible"] > svg': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px', border: '1px none black', borderRadius: '999px' }),
                '&:hover': {
                    backgroundColor: 'unset',
                },
            },
        },
    },
    MuiCheckbox: {
        defaultProps: {
            checkedIcon: (_jsx(CheckboxOn, { sx: {
                    width: tokens.uiElementSelections.iconSize,
                    height: tokens.uiElementSelections.iconSize,
                } })),
            icon: (_jsx(CheckboxOff, { sx: {
                    width: tokens.uiElementSelections.iconSize,
                    height: tokens.uiElementSelections.iconSize,
                } })),
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                padding: 0,
                color: colors.Primary500,
                '&[class*="Mui-disabled"]': {
                    color: colors.Gray500, // Icon color
                },
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                '&[class*="Mui-focusVisible"] > svg': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px', border: '1px none black', borderRadius: '2px' }),
            },
        },
    },
    MuiSwitch: {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                padding: 0,
                height: tokens.uiElementSelections.toggleHeight,
                width: tokens.uiElementSelections.toggleWidth,
                overflow: 'visible',
            },
            track: {
                borderRadius: 999,
                backgroundColor: 'unset',
                borderWidth: '1.5px',
                borderColor: colors.Primary500,
                borderStyle: 'solid',
                opacity: 1,
            },
            thumb: {
                width: tokens.uiElementSelections.thumbSize,
                height: tokens.uiElementSelections.thumbSize,
                borderRadius: 999,
                boxShadow: 'unset',
                borderWidth: '1.5px',
                borderColor: colors.Primary500,
                borderStyle: 'solid',
            },
            switchBase: ({ ownerState }) => ({
                padding: '3.5px',
                '&[class*="Mui-disabled"]': {
                    color: colors.Gray500,
                    '& > [class*="MuiSwitch-thumb"]': {
                        borderColor: colors.Gray500,
                        backgroundColor: colors.White, // To override disabled color change
                    },
                },
                '& > [class*="MuiSvgIcon-root"]': {
                    marginLeft: '-3px',
                    marginTop: '-7px',
                },
                '&[class*="Mui-disabled"] + [class*="MuiSwitch-track"]': {
                    borderColor: colors.Gray500,
                    opacity: ownerState.icon ? 0 : 1,
                },
                '&[class*="Mui-checked"]': {
                    color: colors.White,
                    WebkitTransform: 'translateX(45%)',
                    transform: 'translateX(45%)',
                    '& + [class*="MuiSwitch-track"]': {
                        opacity: 1,
                        backgroundColor: colors.Primary500,
                    },
                    '&[class*="Mui-disabled"] + [class*="MuiSwitch-track"]': {
                        backgroundColor: colors.Gray500,
                        borderColor: colors.Gray500,
                        opacity: 1,
                    },
                    '& > [class*="MuiSwitch-thumb"]': {
                        borderColor: colors.White,
                        backgroundColor: colors.White, // To override disabled color change
                    },
                },
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                // Outline the track
                '&[class*="Mui-focusVisible"] + [class*="MuiSwitch-track"]': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '3px' }),
            }),
        },
    },
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                marginLeft: 0,
            },
            label: ({ ownerState }) => ({
                marginLeft: ownerState.labelPlacement === 'end' ? 8 : 0,
                fontSize: typography.baseTypography.size[400].rem,
                lineHeight: typography.baseTypography.height.Small,
                color: colors.Gray900,
                '&[class*="Mui-disabled"]': {
                    color: colors.Gray700,
                    '& > span': {
                        color: colors.Gray600,
                    },
                },
                '& > span': {
                    fontSize: typography.baseTypography.size[200].rem,
                    lineHeight: typography.baseTypography.height.Small,
                    display: 'block',
                    paddingTop: '4px',
                },
            }),
        },
    },
});
